import { useCallback, useEffect, useState } from 'react';
import type { OrderItem } from '../../../types/apiTypes';
import {
  SCAN_SESSION_CLEARED_EVENT,
  loadScannedItems as loadScannedItemsFromCache,
  removeScanSession,
  writeScannedItemIds,
} from '../../../utils/scanSessionCache';

export function usePickSession(sessionKey: string): {
  saveScannedItems: (items: readonly OrderItem[]) => void;
  loadScannedItems: (items: readonly OrderItem[]) => OrderItem[];
  clearScannedItems: () => void;
  scanSessionEpoch: number;
} {
  const [scanSessionEpoch, setScanSessionEpoch] = useState(0);

  useEffect(() => {
    const onCleared = (): void => {
      setScanSessionEpoch((prev) => prev + 1);
    };
    window.addEventListener(SCAN_SESSION_CLEARED_EVENT, onCleared);
    return () => window.removeEventListener(SCAN_SESSION_CLEARED_EVENT, onCleared);
  }, []);

  const saveScannedItems = useCallback((items: readonly OrderItem[]): void => {
    writeScannedItemIds(sessionKey, items);
  }, [sessionKey]);

  const clearScannedItems = useCallback((): void => {
    removeScanSession(sessionKey);
  }, [sessionKey]);

  const loadScannedItems = useCallback((items: readonly OrderItem[]): OrderItem[] => {
    return loadScannedItemsFromCache(sessionKey, items);
  }, [sessionKey]);

  return { saveScannedItems, loadScannedItems, clearScannedItems, scanSessionEpoch };
}
